// blog.js
import Dialog from "./utils/Dialog";
import Media from "./components/Media";
import ShuffleGrid from "./components/Shuffle";
import Pagination from "./components/Pagination";

// Reset Dialog and Media on changes to the listing DOM
document.addEventListener("DOMContentLoaded", () => {
    // Observe changes to the listing
    const observerTarget = document.querySelector('#blog-list [role="list"]');

    if (observerTarget) {
        const config = { attributes: true, childList: true, subtree: true };

        const reset_dialogs = (items) => {
            items.forEach((item) => {
                new Dialog(item);
            });
        };
        const reset_media = (items) => {
            items.forEach((item) => {
                new Media(item);
            });
        };
        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (
                    mutation.type === "childList" &&
                    mutation.target.role == "list"
                ) {
                    // console.log("observing", mutation);
                    let elements =
                        observerTarget.querySelectorAll("[data-dialog]");
                    reset_dialogs(elements);

                    elements = observerTarget.querySelectorAll(
                        "[data-carousel='media'], [data-carousel='media-nav']",
                    );
                    reset_media(elements);
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(observerTarget, config);
    }
});

export const blogListing = (element) => {
    const url = element.action;
    const parser = new DOMParser();
    const target = document.querySelector(element.dataset.target);
    const listing = target.querySelector('[role="list"]');
    const no_results = document.getElementById("no-results");
    const loading_indicator = document.querySelector("loading-indicator");
    const reset_button = document.querySelector('[type="reset"]');

    let pagination = target.querySelector(".pagination");
    // Delegate category change event
    element.addEventListener("change", async (e) => {
        loading_indicator.setAttribute("active", true);
        target.querySelector(".error-text")?.remove();

        // console.log("CHANGE");
        // Collect form data
        let form_data = new FormData(element);

        // Build query string
        let query = [];
        for (const pair of form_data.entries()) {
            if (pair[1]) {
                query.push([`${pair[0]}=${pair[1]}`]);
            }
        }

        // Updates browser history
        if (query.length) {
            query = query.join("&");
            window.history.replaceState(null, null, `?${query}`);
        } else {
            window.history.replaceState(null, null, url);
        }

        // Request filtered content
        const payload = {
            method: "POST",
            credentials: "include",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded",
            }),
            body: query.concat([`&ajax=1`]),
        };
        const response = await fetch(url, payload);
        let data = await response.text();

        // Parse the response into HTML
        var doc = parser.parseFromString(data, "text/html");
        let list = doc.querySelector('[role="list"]');

        if (query.length) {
            reset_button.setAttribute("aria-hidden", false);
        } else {
            reset_button.setAttribute("aria-hidden", true);
        }

        // Replace listing content
        listing.innerHTML = list.innerHTML;

        // Masonry
        if (listing.hasAttribute("data-shuffle")) {
            new ShuffleGrid(listing);
        }

        if (typeof window.instgrm !== "undefined") {
            window.instgrm.Embeds.process();
        }

        // No results
        if (!list.querySelectorAll("[data-id]").length) {
            let noresults = no_results.content.cloneNode(true);
            listing.parentNode.appendChild(noresults);
        }

        // Pagination - Append or remove based on filters results
        let list_pagination = doc.querySelector(".pagination");
        if (list_pagination) {
            if (!pagination) {
                target.appendChild(list_pagination);
            } else {
                pagination.innerHTML = list_pagination.innerHTML;
                pagination.style.display = "block";
            }

            pagination = target.querySelector(".pagination");
            new Pagination(pagination);
        } else {
            pagination?.remove();
            pagination = null;
        }

        loading_indicator.setAttribute("active", false);
    });

    reset_button.addEventListener("click", (e) => {
        e.preventDefault();
        element.querySelectorAll("select").forEach((item) => {
            item.value = "";
        });
        reset_button.setAttribute("aria-hidden", true);
        element.dispatchEvent(new Event("change"));
    });
};

document.addEventListener("DOMContentLoaded", () => {
    const element = document.getElementById("blog-filters");

    if (element) {
        blogListing(element);
    }
});
